module.exports = __webpack_public_path__ + "media/images/icons/eu-logo-6f389b967e0dc9c0c00a5a17cec748a6.svg";